import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import ResourceActionButton from './ResourceActionButton';

type Props = Omit<React.ComponentProps<typeof ResourceActionButton>, 'icon'>;

const ResourceAddButton = React.forwardRef<HTMLButtonElement, Props>((props, ref) => (
	<ResourceActionButton {...props} ref={ref} icon={<PlusOutlined />} />
));

ResourceAddButton.displayName = 'ResourceAddButton';
export default ResourceAddButton;
